import _ from 'lodash'

export default class Enum {
  constructor(entries, options={}) {
    if (Array.isArray(entries)) {
      entries = entries.reduce((a, k) => { a[k] = {}; return a }, {})
    }

    this.keys = []
    this.entries = []
    this.entriesByKey = {}
    this.defaultValue = options.defaultValue || null

    for (let key in entries) {
      this[key] = key
      const entry = { key, ...entries[key] }
      this.entriesByKey[key] = entry
      this.entries.push(entry)
      this.keys.push(key)
    }

    Object.freeze(this.keys)
    Object.freeze(this.entries)
    Object.freeze(this.entriesByKey)
  }

  resolve(key) { return key || this.defaultValue }

  isValid(key) {
    return !!this.entriesByKey[key]
  }
}

export class ServerValueEnum extends Enum {
  mapEnumKeyToServerValue() {
    return this._mapEnumKeyToServerValue || (
      this._mapEnumKeyToServerValue = _.transform(this.entries, (all, entry) => (all[entry.key] = entry.serverValue), {})
    )
  }

  mapServerValueToEnumKey() {
    return this._mapServerValueToEnumKey || (this._mapServerValueToEnumKey = _.invert(this.mapEnumKeyToServerValue()))
  }

  fromServer(serverValue) {
    return this.mapServerValueToEnumKey()[serverValue]
  }

  toServer(key) {
    return this.mapEnumKeyToServerValue()[this.resolve(key)]
  }

  resolve(key) {
    return (this.isValid(key) ? key : this.fromServer(key)) || this.defaultValue
  }
}
